﻿import React, { useState, useEffect, useRef } from "react";
import axios from "../../features/axiosHelper";
import { TextField, Button, Typography, Box, Divider } from "@mui/material";
import { GoogleIcon, MicrosoftIcon } from "../../ImageRepo";

const ForgotPasswordPane = ({
  setUserCredentialsPane,
  setForgotPasswordPane,
  setEnvironmentSelectionPane,
}) => {
  const [Email, setEmail] = useState("");
  const [Error, setError] = useState(false);
  const [RequestedCode, setRequestedCode] = useState(false);
  const [Cooldown, setCooldown] = useState(0);
  const timerRef = useRef(null);
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const startCooldown = () => {
    setCooldown(60);
    timerRef.current = setInterval(() => {
      setCooldown((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  useEffect(() => () => clearInterval(timerRef.current), []);

  const ForgotPassword = () => {
    axios
      .post("/login/users/reset", Email, {})
      .then((response) => {
        setRequestedCode(true);
        setError(false);
        startCooldown();
        window.heap.track("Login - Forgot Password");
      })
      .catch((err) => {
        setError(true);
      });
  };
  return (
    <div className="centerContent">
      <Typography
        sx={{
          color: "#FFFFFF !important",
          fontSize: "32px !important",
          fontWeight: "600 !important",
          fontFamily: "mortise !important",
        }}
      >
        {RequestedCode ? "Please check your inbox!" : "Reset Your Password?"}
      </Typography>
      <Typography
        sx={{
          color: "#767676 !important",
          fontSize: "24px !important",
          fontWeight: "400 !important",
          fontFamily: "mortise !important",
        }}
      ></Typography>
      <br />
      <Typography sx={{ color: "var(--text-adornment)" }}>
        {RequestedCode
          ? "If an account is associated with this email address, you will receive a password reset link shortly."
          : "Enter your registered email address and we'll send you a link to reset it."}
      </Typography>
      <br />
      <br />
      <Typography
        sx={{
          color: "var(--default-light)",
          fontSize: "15px",
          fontWeight: 400,
          mb: 1,
        }}
      >
        Email Address
      </Typography>
      <TextField
        sx={{
          "& .MuiOutlinedInput-root": {
            backgroundColor: "var(--dark-border)",
            height: "60px",
            borderRadius: "8px",
            "& fieldset": {
              borderColor: "var(--neutral-6)",
              borderWidth: "1px",
            },
            "&:hover": {
              backgroundColor: "var(--dark-border)",
              boxShadow: "0px -1px 8.2px rgba(204, 204, 204, 0.75)",
              "& fieldset": {
                borderColor: "var(--neutral-6)",
                borderWidth: "1px",
              },
            },
            "&.Mui-focused": {
              backgroundColor: "var(--dark-border)",
              "& fieldset": {
                borderColor: "var(--neutral-6)",
                borderWidth: "1px",
              },
            },
            "& #emailForgotPWTextfield.MuiInputBase-input": {
              color: "var(--default-light)",
              padding: "14px",
              height: "100%",
              "&::selection": {
                backgroundColor: "#555",
                color: "white",
              },
              "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 1000px var(--background-color) inset",
                WebkitTextFillColor: "var(--default-light)",
                caretColor: "var(--default-light)",
                borderRadius: "4px",
                transition: "background-color 9999s ease-in-out 0s",
              },
              "&:-webkit-autofill:hover": {
                WebkitBoxShadow: "0 0 0 1000px var(--background-color) inset",
                WebkitTextFillColor: "var(--default-light)",
              },
              "&:-webkit-autofill:focus": {
                WebkitBoxShadow: "0 0 0 1000px var(--background-color) inset",
                WebkitTextFillColor: "var(--default-light)",
              },
            },
          },
        }}
        id="emailForgotPWTextfield"
        error={Error}
        helperText={Error ? "Could not send email to this account" : ""}
        fullWidth={true}
        variant="outlined"
        onChange={handleEmailChange}
        inputProps={{ style: { fontFamily: "var(--font-family)" } }}
      />
      <br />
      <br />
      <Button
        fullWidth={true}
        onClick={() => ForgotPassword()}
        disabled={Cooldown > 0}
        sx={{
          marginTop: "20px",
          width: "100%",
          height: "60px",
          backgroundColor: "var(--default-light)",
          color: "var(--text-primary)",
          fontFamily: "Montserrat",
          fontWeight: "medium",
          fontSize: "24px",
          borderRadius: "8px",
          textTransform: "none",
          "&:hover": {
            backgroundColor: "var(--text-primary)",
            fontWeight: 600,
            color: "var(--default-light)",
            border: "1px solid var(--default-light)",
          },
          "&:disabled": {
            backgroundColor: "var(--default-light)",
            color: "rgba(12,12,12,0.5)",
          },
          boxShadow: "none",
          "&.MuiButton-root": {
            boxShadow: "none",
          },
        }}
      >
        {RequestedCode
          ? Cooldown > 0
            ? `Resend Link (${Cooldown}s)`
            : "Resend Link"
          : "Send Reset Link"}
      </Button>
      <div className="externalLoginSection">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            my: 3,
            color: "white",
          }}
        >
          <Divider
            sx={{
              flexGrow: 1,
              backgroundColor: "var(--neutral-6)",
              height: "1px",
            }}
          />
          <Typography
            variant="body1"
            sx={{
              px: 2,
              fontSize: "14px",
              color: "var(--grey-lowlight)",
            }}
          >
            Or Login With
          </Typography>
          <Divider
            sx={{
              flexGrow: 1,
              backgroundColor: "var(--neutral-6)",
              height: "1px",
            }}
          />
        </Box>
      </div>{" "}
      <form
        method="GET"
        action={"/api/login/users/external"}
        className="externalLoginSection"
      >
        <div className="externalLoginButtonsWrapper">
          <Button
            className="externalLoginButton btn-secondary"
            type="submit"
            name="provider"
            value="Google"
          >
            <img src={GoogleIcon} alt="GoogleIcon" />
            Sign In
          </Button>
          <Button
            className="externalLoginButton btn-secondary"
            type="submit"
            name="provider"
            value="Microsoft"
          >
            <img src={MicrosoftIcon} alt="MicrosoftIcon" />
            Sign In
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ForgotPasswordPane;
